// src/features/inventory/pages/ItemDetailPage/tabs/StockLog/index.jsx
import React, { useEffect } from 'react';
import { useStockTransactions } from '../../../../hooks/useStockTransactions';
import { useStockLocations } from '../../../../hooks/useStockLocations';
import StockLogDataGrid from '../../../../components/StockLogDataGrid';

export default function StockLog({ itemId, lotTracked, refreshKey }) {
  const { transactions, loading, error, clearError, fetchTransactions } = useStockTransactions();
  const { stockLocations, fetchStockLocations } = useStockLocations();

  useEffect(() => {
    fetchTransactions(itemId);
    fetchStockLocations();
  }, [fetchTransactions, fetchStockLocations, itemId, refreshKey]);

  return (
    <StockLogDataGrid
      transactions={transactions}
      loading={loading}
      error={error}
      onClearError={clearError}
      showLotColumn={lotTracked}
      showLocationColumn
      locations={stockLocations}
    />
  );
}
